import React, { useState } from "react"
import {  Box, Checkbox, FormControl, IconButton, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, Tooltip } from "@mui/material"
import { InputStyle } from "./style"
import { HighlightOff } from "@mui/icons-material"

export type SelectOption = {
    item: string,
    icon?: React.ReactNode
}

export const MultipleSelectInput = ({title, options, values, required, onClose}:{
    title: string
    options: SelectOption[]
    values: string[]
    required?: boolean
    onClose: (val: string[]) => void
}) => {
    const labelId = `select-${title}-label`
    const [open, setOpen] = useState<boolean>(false)
    const [selected, setSelected] = useState<string[]>(values)

    const handleChange = (event: SelectChangeEvent<string | string[]>) => {
        const {
        target: { value },
        } = event;
        setSelected(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
    };

    const select = (
        <Select 
            labelId={labelId}
            label={title}
            id={`select-${title}-control`}
            type="text"
            value={selected}
            multiple
            renderValue={(selected) => selected.length > 1 ? `${selected.length} selections` : selected.toString()}
            open= {open}
            onChange={handleChange}
            onOpen={() =>{
                setOpen(true)
            }}
            onClose={() => {
                onClose(selected)
                setOpen(false)}}
            >
                {options.map((i, idx) => (
                    <MenuItem key={idx} value={i.item}>
                        <Checkbox checked={selected.includes(i.item)}/>
                        {i.icon}
                        <ListItemText primary={i.item}/>
                    </MenuItem>
                ))}
        </Select>

    )

    return (
      <Box>
        <FormControl 
          {...InputStyle}
          sx={{
              width:200,
              marginBottom:'0px',
              marginTop:'0px',
              marginLeft:'9px'
          }}
          required={required}
          >
          <InputLabel id={labelId}>
              {title}
          </InputLabel>
          {
              open || values.length <= 1 ?
                  (select)
              :(
                  <Tooltip title={values.join(', ')} disableHoverListener={open}>
                      {select}
                  </Tooltip>
              )
          }
        </FormControl> 
        <Tooltip title="Clear selection">
          <IconButton 
            onClick={() => {
              setSelected([])
              setOpen(false)
              onClose([])
            }} 
            disabled={selected.length === 0}>
            <HighlightOff/>
          </IconButton>
        </Tooltip>
      </Box>
    )
}